import React from 'react'

import { Typography } from "@mui/material"


export default function frequencyHoursColumn() {

	return {
		name: 'frequencyHours',
		label: 'Frequency Hours',
		options: {
            customBodyRowRenderLite: value => <Typography sx={{ textAlign: "center" }}>{value?.map(v => v.length === 4 ? `0${v}` : v).join(', ')}</Typography>,
		}
	}
}